import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui/layout/layout';

import { type EnforcedExcludedApp } from '../team.types';

export const PLATFORM_LABELS = { mac: 'Mac', windows: 'Windows' } as const;

/** The OS the apps cover and the one they leave out, when they cover only one */
export const platformGap = (apps: EnforcedExcludedApp[]) => {
  const hasMac = apps.some((app) => app.platform === 'mac');
  if (hasMac === apps.some((app) => app.platform === 'windows')) return null;
  return hasMac
    ? { applied: 'Mac', missing: 'Windows' }
    : { applied: 'Windows', missing: 'Mac' };
};

export const singlePlatformWarning = ({
  applied,
  missing,
}: {
  applied: string;
  missing: string;
}) =>
  `Only applied on ${applied}. An admin on ${missing} needs to add ${missing} apps.`;

export const TeamPlatformWarning = ({ message }: { message: string }) => (
  <XStack className="w-full items-start gap-2 rounded-lg border border-warning-5 dark:border-warning-3 bg-warning-2 px-3 py-2">
    <Icons.warnTriangle className="mt-0.5 size-4 shrink-0 text-warning-11" />
    <span className="text-sm leading-5 text-warning-11">{message}</span>
  </XStack>
);
